export const homeObjOne = {
    id:'about',
    lightBg:true,
    lightText:true,
    lightTextDesc:true,
    topLine:'Jaime Ivan Ramirez Osorio " El Jimmy "',
    headline:'Desarrollador Front-End',
    description:'Ingeniero en Sistemas Computacionales, apasionado por el Desarrollo Front-End, con más de 2 años de experiencia laboral haciendo uso de React.js, HTML 5, CSS 3, JavaScript, PHP y demás herramientas web.',
    description_1:'Día con día sigo aprendiendo sobre las diversas tecnologías web esto para mejorar la calidad de mi programación y conocimiento.',
    buttonLabel:'Experiencia Laboral',
    buttonCV:'Descargar CV',
    imgStart:false,
    ImgSv: require('../../images/16478986157581.svg').default,
    dark:false,
    primary:true,
    darkText:false
};